// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const hookInterfaceListQuerySchema = z
  .object({
    name: z.string(),
    hook: idSchema,
    type: z.string(),
    canInvoke: z.boolean(),
  })
  .partial()
  .and(paginationQuerySchema);
